module.exports = __webpack_public_path__ + "static/media/ic_bar_char_fixed.f33cd497.svg";